import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes,useParams  } from 'react-router-dom';

import './index.css';
import App from './App';
// import App_cn from './App_cn';
import Home from './Home';
import ErrorPage from "./error-page";
import Admin from './admin';
import Zero from './Zero';
import Bookingadmin from './Bookingadmin';
import Bookingstudent from './Bookingstudent';
import Bookingteacher from './Bookingteacher';
import Myschedule from './Studentsched';
import Adminuserlist from './Adminuserlist'


// import Session_messages from './session_messages';
// import reportWebVitals from './reportWebVitals';

// import {
//   createBrowserRouter,
//   RouterProvider,
// } from "react-router-dom";


const BookingComponent = () => {
  const { user_type } = useParams();

  let bookingContent;
  switch (user_type) {
    case "0": // Admin
      bookingContent = <Bookingadmin />;
      break;
    case "1": // Student
      bookingContent = <Bookingstudent />;
      break;
    case "2": // Teacher
      bookingContent = <Bookingteacher />;
      break;
    default:
      // Handle other cases or show an error message
      bookingContent = <div><ErrorPage/></div>;
  }

  return <div>{bookingContent}</div>;
};

function MyRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:id/:user_name/:key/:user_type/myschedule" element={<Myschedule />} />
        <Route path="/:id/:user_name/:key/:user_type/booking" element={<BookingComponent />} />
        <Route path="/:user_id/:user_name/:user_key/:user_type/userlist" element={<Adminuserlist/>} />
        <Route path="/chat/:learnLanguage/:nativeLanguage/:chat_id/:student_id" element={<App />} />
        <Route path="/admin/:admin_key" element={<Admin />} />
        <Route path="/zerolevel/" element={<Zero />} />

        {/* <Route path="/session_messages/:session_id/:chat_id" element={<Session_messages />} /> */}
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

// const router = createBrowserRouter([
//   {
//     path: "/",
//     element: <Home />,
//     errorElement: <ErrorPage />,
//   },
//   {
//     path: "chat_a0451x",
//     element: <App />,
//   },
//   {
//     path: "chat_x0571d",
//     element: <App />,
//   },
// ]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <MyRouter />
  // </React.StrictMode>
);


